export default __webpack_public_path__ + "static/media/Sword of the Death Master.a7e8dfa1.jpg";